import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Sidebar from "./common/Sidebar";
import Overview from "./pages";
import DarkModeProvider from "./darkModeContext";
import Onboarding from "./common/Onboarding";
import 'mapbox-gl/dist/mapbox-gl.css';
import './appInsights/appInsights';

import { IntlProvider } from 'react-intl';
import { useAppWideI18n } from "./i18n";
import { AboutUsPage } from "./about-us/aboutUs";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <div className="App">
      <DarkModeProvider>
        <App />
      </DarkModeProvider>
    </div>
  </BrowserRouter>
);

function App() {
  const [messages, [language, setLanguage]] = useAppWideI18n();
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("onboarding-seen")) {
      setShowOnboarding(true);
      localStorage.setItem("onboarding-seen", JSON.stringify(true));
    }
  }, []);

  return <IntlProvider
    locale={language}
    messages={messages[language] ?? messages['en']}
    defaultLocale="en"
  >
    <div className="with-sidebar">
      <Sidebar setShowOnboarding={setShowOnboarding} language={language} setLanguage={setLanguage} />
      <div className="not-sidebar">
        <Routes>
          <Route path="/about" element={<AboutUsPage />}></Route>
          <Route path="*" element={<Overview />}></Route>
        </Routes>
        {showOnboarding && <Onboarding setShowOnboarding={setShowOnboarding} />}
      </div>
    </div>
  </IntlProvider>;
}